import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiBadgeVariant } from '../../models/ui-badge.model';

@Component({
  selector: 'app-ui-document-panel-shell',
  templateUrl: './ui-document-panel-shell.component.html',
  styleUrls: ['./ui-document-panel-shell.component.scss']
})
export class UiDocumentPanelShellComponent {
  @Input() breadcrumb = '';
  @Input() title = '';
  @Input() documentId = '';
  @Input() statusLabel = '';
  @Input() statusVariant: UiBadgeVariant = 'default';
  @Input() showClose = true;
  @Output() closed = new EventEmitter<void>();

  onClose(): void {
    this.closed.emit();
  }
}
